// Cache genérico em memória (stale-while-revalidate) para listas de páginas como Contatos e Grupos.
// Vive durante a sessão da aba; NÃO é persistido em storage.
//
// ⚠️ SEGURANÇA MULTI-TENANT: precisa ser limpo em QUALQUER troca de auth (login, logout,
// impersonação) para nunca mostrar dados de um tenant a outro. Isso é garantido porque o
// clearMessagesCache() (chamado no AuthContext em toda troca de auth) também chama clearListCache().
//
// LRU pequeno, chaveado por (namespace + filtros), para reentrar na tela ser instantâneo.

const MAX_ENTRIES = 12;
const cache = new Map(); // key -> { value, ts }

export function getListCache(key) {
  const hit = cache.get(key);
  if (hit) {
    // Renova a recência (LRU): remove e reinsere no fim.
    cache.delete(key);
    cache.set(key, hit);
    return hit;
  }
  return null;
}

export function setListCache(key, value) {
  if (cache.has(key)) cache.delete(key);
  cache.set(key, { value, ts: Date.now() });
  while (cache.size > MAX_ENTRIES) {
    const oldest = cache.keys().next().value;
    cache.delete(oldest);
  }
}

export function clearListCache() {
  cache.clear();
}
